export default {
  host: process.env.VUE_APP_API_HOST || 'https://qhnyjs.cn',
  port: process.env.VUE_APP_API_PORT || '',
  socketurl: process.env.VUE_APP_WS_URL || 'wss://qhnyjs.cn/ws',
};